import React, { useRef, useState, useEffect, useCallback, useMemo } from 'react'
import { useRouter } from 'next/router'
import Swal from 'sweetalert2'
import AwesomeSlider from 'react-awesome-slider'
import 'react-awesome-slider/dist/styles.css'
import useSWR from 'swr'
import { fetchRegionsv2 } from '../../api'
import cookie from 'js-cookie'
import { createCustomPreOrder, resetOrderAndCart } from 'actions'
import { BusinessSearch } from 'components'
import {
  Modal,
  CloseIcon,
  Carousel,
  RightArrow,
  LeftArrow
} from 'components/common'
import s from './ServiceListPage.module.css'
import DeliveryTimeModal from 'components/DeliveryTimeModal/DeliveryTimeModal'
import TopMenu from '../../components/ServiceList/TopMenu'
import { getPosition } from 'utils'
import BusinessListCard from 'components/BusinessListCard/BusinessListCard'
import useRestaurants from 'components/hooks/useRestaurants'
import { ModalRef } from 'components/common/Modal/Modal'
import {
  useAppDispatch,
  useAppSelector
} from 'components/hooks/redux-selectors'
import { allOrderDetails } from 'actions'
import {
  DeliveryType,
  ORDER_STATUS,
  ServiceListBusiness,
  ServiceTime
} from 'components/common/types'
import Spinner from 'components/common/Spinner/Spinner'
import OrderProgressModal from 'components/common/OrderProgressModal/OrderProgressModal'
import {
  SERVICE_LIST_SET_SELECTED_REGION,
  SERVICE_LIST_SUCCESS,
  SET_SERVICE_TIME_DETAILS
} from 'constants/actionTypes'
import { checkIsSpecialBusiness } from 'utils/businessHelpers'
import ScrollChecker from 'components/ServiceList/ScrollChecker'
import ScrollY from 'components/ScrollY/ScrollY'
import { toast } from 'react-toastify'
import PhoneCountryCodeRow from 'components/OrderSteps/common/PhoneCountryCodeRow'
import ConfirmationModal from 'components/common/ConfirmationModal/ConfirmationModal'

const Services = ({ regions }) => {
  const [searchedBusinesses, setSearchedRestaurants] = useState<
    ServiceListBusiness[] | undefined
  >([])
  const [searchedText, setSearchedText] = useState('')
  const [latitude, setLatitude] = useState(cookie.get('latitude'))
  const [longitude, setLongitude] = useState(cookie.get('longitude'))

  const orderProgressModalRef = useRef<ModalRef>(null)
  const businessSearchRef = useRef(null)

  const router = useRouter()
  const dispatch = useAppDispatch()

  const { isAuthenticated } = useAppSelector((state) => state.auth)
  
  const currentCartItems = useAppSelector((state) => state.cart.items);
  const currentCartbusinessName = useAppSelector((state) => state.cart.businessName);
  const serviceDeliveryOptions = useAppSelector(
    (state) => state.serviceDeliveryOptions
  )

  const regionQuery = (router?.query?.index as string[])[0]
  const serviceQuery = (router?.query?.index as string[])[1]

  const regionId = regionQuery ? regionQuery : undefined
  const serviceId = serviceQuery ? serviceQuery : undefined
  const shoppingListModalRef = useRef<ModalRef>(null) 
  const waringModalRef = useRef<ModalRef>(null) 
  const [phoneNumber, setPhoneNumber] = useState('');
  const [customOrderNotes, setCustomOrderNotes] = useState('');
  const [preOrderCreated, setPreOrderCreated] = useState(false);
  const [preOrderId, setpreOrderId] = useState<Number | null>(null);
  const [noOfFilesUploaded, setNoOfFilesUploaded] = useState<Number>(0);
  const [previewImage, setPreviewImage] = useState<string | null>(null);
  const [selectedFile, setSelectedFile] = useState<File | null>(null);
  const [isImageViewerOpen, setImageViewerOpen] = useState(false);
  const [uploadedImages, setUploadedImages] = useState<{ ImageUrl: string; CustomerNotes: string | null }[]>([]);
  const handleImageChange = (e: React.ChangeEvent<HTMLInputElement>) => {
      const file = e.target.files?.[0];
      if (file) {
        const reader = new FileReader();
        reader.onloadend = () => {
          setPreviewImage(reader.result as string);
          setSelectedFile(file);
        };
        reader.readAsDataURL(file);
      }
  };
  const handlePhoneNumberChange = (newPhone) => {
      setPhone(newPhone);
  };
  const handleCountryCodeChange = (countryListItem) => {
      setPhoneDialDetails(countryListItem);
  };
  const handleAddMoreClick = () => {
      document.getElementById("uploadInput").click();
  };
  const handleDoneClick = async () => {
    try {
      await handleSubmit();
      setpreOrderId(null); // This will hide the "I am Done" button
      setSelectedFile(null);
      setPreOrderCreated(false);
      setPreviewImage(null);
      setCustomOrderNotes('');
      setPhoneNumber('');
      setPhone('');
      setNoOfFilesUploaded(0);
      setUploadedImages([]);
    } catch (error) {
      console.error('Error in order submission:', error);
    }
  };
  const CustomToastContent = () => (
    <div>
      <p>You must provide the following:</p>
      <ul style={{ margin: 0, paddingLeft: '20px' }}>
        <li>Your full phone number.</li>
        <li>A picture of your shopping list or the shopping list written in the notes on this page.</li>
      </ul>
      <p>We'll contact you via WhatsApp to confirm your list.</p>
    </div>
  );
  const handleSubmit = async (event?: React.FormEvent) => {
      if (!isAuthenticated) {
        shoppingListModalRef.current?.closeModal();
        toast.error('You are not logged in.', {
          autoClose: 3000,
          onClose: () => router.push('/login')
        })
      }
      event?.preventDefault();
      setPhoneNumber(`${phoneDialDetails?.dialCode}${phone}`)
      if (
          !(selectedFile || customOrderNotes) ||
          !phoneDialDetails?.dialCode || 
          !phone || 
          `${phoneDialDetails.dialCode}${phone}`.length < 11 || 
          !selectedBusiness?.id
        ) {
        toast.error(<CustomToastContent />, 
        { autoClose: 2000 });
        return;
    }
    try {
      const result = await dispatch(
        createCustomPreOrder(
          selectedBusiness.id, 
          `${phoneDialDetails?.dialCode}${phone}`, 
          selectedFile,
          customOrderNotes,
          preOrderId
        )
      );
      if (result.Status) {
      setPreOrderCreated(true);
      setpreOrderId(result.Data.Id)
      setSelectedFile(null);
      setPreviewImage(null);
      const imagesWithNotes = result.ImagesNotes.map(note => ({
                ImageUrl: note.ImageUrl,
                CustomerNotes: note.CustomerNotes
            }));
      setUploadedImages(imagesWithNotes);
      setNoOfFilesUploaded(imagesWithNotes.length);
      }
      if (!result.Status) {
          toast.error(result.message, { autoClose: 2000 });
      }
    } catch (error) {
      console.error('Error:', error);
    }
  };

  const { restaurants: businessListData, isLoading: restaurantLoading } =
    useRestaurants({
      regionId,
      serviceId,
      latitude,
      longitude,
      onSuccess: () => {
        businessSearchRef.current!.resetBusinessSearch()
        setSearchedRestaurants([])
        setSearchedText('')
      }
    })

  useEffect(() => {
    dispatch({
      type: SERVICE_LIST_SUCCESS,
      payload: businessListData
    })
    dispatch({
      type: SERVICE_LIST_SET_SELECTED_REGION,
      payload: selectedRegion
    })
  }, [businessListData])

  const restaurantsData = useMemo(() => {
  return businessListData?.businesses?.filter((restaurant) => {
    if (
      serviceDeliveryOptions.deliveryType === DeliveryType.DELIVER &&
      checkIsSpecialBusiness(businessListData.business_type_id)
    ) {
      return true; // Include all restaurants regardless of `restaurant.delivery`
    }

    if (
      serviceDeliveryOptions.deliveryType === DeliveryType.PICK_UP &&
      checkIsSpecialBusiness(businessListData.business_type_id)
    ) {
      return true; // Include all restaurants regardless of `restaurant.pickup`
    }

    return true; // Default inclusion of all restaurants
  });
}, [businessListData, serviceDeliveryOptions.deliveryType]);

  // const { data: regions } = useSWR('/regions', fetchRegionsv2, {
  //   revalidateOnFocus: false,
  //   revalidateOnMount: false
  // })
  const { data: selectedRegion, mutate: setSelectedRegion } =
    useSWR('/selected-region')

  const [selectedBusiness, setSelectedBusiness] =
    useState<ServiceListBusiness | null>(null)
  const [selectedItem, setSelectedItem] = useState<ServiceListBusiness | null>(null);
  const [modalItems, setModalItems] = useState([])
  const [phone, setPhone] = useState('');
  const [phoneDialDetails, setPhoneDialDetails] = useState(null);
  const specialModalRef = useRef<ModalRef>(null)
  const deliveryTimeModalRef = useRef<ModalRef>(null)
  const serviceStatusModalRef = useRef<ModalRef>(null)

  useEffect(() => {
    if (selectedRegion?.service_messages?.length) {
      serviceStatusModalRef.current?.openModal()
    }
  }, [selectedRegion])

  useEffect(() => {
    getPosition()
      .then(({ position }) => {
        setLatitude(`${position.coords.latitude}`)
        setLongitude(`${position.coords.longitude}`)
        cookie.set('latitude', `${position.coords.latitude}`)
        cookie.set('longitude', `${position.coords.longitude}`)
      })
      .catch((error) => {
        console.error(error)
      })

    window.scrollTo(0, 0)

    if (isAuthenticated) {
      dispatch(allOrderDetails()).then((allOrders) => {
        const foundPendingOrder = allOrders.pending.findIndex(
          (order) => order.orderStatus === ORDER_STATUS.PENDING
        )

        if (foundPendingOrder !== -1) {
          orderProgressModalRef.current?.openModal()
        }
      })
    }

    const currentTimeInTimeStamp = new Date().getTime()
    const plannedDeliveryTimeInTimeStamp = new Date(
      serviceDeliveryOptions.deliveryDate
    ).getTime()

    // If currentTime is bigger than planned delivery time remove delivery time and delivery date
    // and set it to asap since it is default value
    if (currentTimeInTimeStamp > plannedDeliveryTimeInTimeStamp) {
      dispatch({
        type: SET_SERVICE_TIME_DETAILS,
        payload: {
          serviceTime: ServiceTime.ASAP,
          deliveryDate: ''
        }
      })
    }
  }, [])

  useEffect(() => {
    const localSelectedRegion =
      regions.find((region) => region.slug === regionId) ?? {}

    setSelectedRegion(localSelectedRegion)
  }, [router.asPath])

  const handleUploadClick = useCallback((business: ServiceListBusiness) => {
    setSelectedBusiness(business)
    shoppingListModalRef.current?.openModal()
  }, [])
  const handleContinue = () => {
    if (selectedItem) {
      const link = `/biz/${selectedItem.slug}${isInvoicesSelected ? '?invoices=true' : ''}`;
      waringModalRef.current!.closeModal();
      dispatch(resetOrderAndCart())
      router.push(link);
    }
  };
  const handleCancel = () => {
    waringModalRef.current!.closeModal();
  };
  const conditionalData = searchedText ? searchedBusinesses : restaurantsData
  const isInvoicesSelected = Number(serviceId) === 69;//service id for my invoices tab

  const restaurantList = conditionalData?.map((item) => {
    return (
      <BusinessListCard
        key={item.id}
        isInvoicesSelected= {isInvoicesSelected}
        data={item}
        onSpecialClick={() => {
          setModalItems(item.special)
          specialModalRef.current!.openModal()
        }}
        onImageClick={() => {
          const link = `/biz/${item.slug}${isInvoicesSelected ? '?invoices=true' : ''}`
          if (currentCartItems.length > 0 && currentCartbusinessName != item.name) {
            setSelectedItem(item);
            waringModalRef.current!.openModal();
          }
          else{
            if (item.disclaimer) {
            Swal.fire({
              width: 600,
              title: item.disclaimer,
              showCancelButton: true,
              confirmButtonColor: 'green',
              cancelButtonColor: '#d33',
              confirmButtonText: 'Come In',
              customClass: {
                title: s.sweetAlertContent
              }
            }).then((result) => {
              if (result.isConfirmed) {
                router.push(link)
              }
            })
          } else {
            router.push(link)
          }
          }
        }}
        onClockIconClick={() => {
          setSelectedBusiness(item)

          deliveryTimeModalRef.current!.openModal()
        }}
        onUploadClick={() => handleUploadClick(item)}
      />
    )
  })

  const handleBusinessSearch = useCallback(
    (searchValue) => {
      const filteredSearchedBusinesses = restaurantsData?.filter((business) => {
        const businessSearchValue = business.keywords.reduce((acc, curr) => {
          return `${acc} ${curr}`
        }, business.name)
        return businessSearchValue
          .toLowerCase()
          .includes(searchValue.toLowerCase())
      })

      setSearchedRestaurants(filteredSearchedBusinesses)
      setSearchedText(searchValue)
    },
    [restaurantsData]
  )

  return (
    <div className="content mt-[113px] xl:mt-[35px]">
      <div className="mt-4">
        <TopMenu
          selectedRegion={selectedRegion}
          regionSlug={regionId}
          serviceSlug={serviceId}
          regions={regions}
          services={selectedRegion?.services}
          onRegionChange={() => {}}
        />
      </div>

      <div className="mt-4 flex flex-1 md:mt-0"></div>

      <div className="min-h-[50px] mt-4">
        <ScrollY>
          {(pageOffset) => (
            <ScrollChecker
              pageOffset={pageOffset}
              elementId="business-search"
              toggleClass={() => s.stickyBusinessSearch}
              shouldToggleOn={pageOffset > 200}
            >
              <BusinessSearch
                ref={businessSearchRef}
                onBusinessSearch={handleBusinessSearch}
              />
            </ScrollChecker>
          )}
        </ScrollY>
      </div>

      {searchedText && searchedBusinesses && (
        <div className="mb-12 text-4xl">
          {searchedBusinesses.length === 0 && (
            <div>
              No results for
              <span className="ml-3 font-bold">"{searchedText}"</span>
            </div>
          )}

          {searchedBusinesses.length !== 0 && (
            <>
              <span className="mr-2"> {searchedBusinesses.length}</span>
              <span className="mr-2">
                {searchedBusinesses.length === 1 ? 'result' : 'results'}
              </span>
              for
              <span className="ml-3 font-bold">"{searchedText}"</span>
            </>
          )}
        </div>
      )}

      <div className={s.restaurants}>
        {restaurantLoading ? <Spinner /> : restaurantList}
      </div>

      <Modal ref={deliveryTimeModalRef} className={s.timeModal}>
        {selectedBusiness && (
          <DeliveryTimeModal
            lat={selectedBusiness?.lat}
            long={selectedBusiness.long}
            name={selectedBusiness.name}
            address={selectedBusiness.address}
            delivery_hours={selectedBusiness.delivery_hours}
          />
        )}
      </Modal>

      <Modal
        className={s.specialModal}
        ref={specialModalRef}
        headerActive={false}
      >
        <AwesomeSlider className={s.slider} infinite={false}>
          {modalItems.map((item) => (
            <div data-src={item} className={s.sliderImg} />
          ))}
        </AwesomeSlider>
      </Modal>

      <Modal
        className={s.serviceStatusModal}
        ref={serviceStatusModalRef}
        headerActive={false}
        shouldCloseOnOverlayClick
      >
        <Carousel items={selectedRegion?.service_messages}>
          {({ onPreviousClick, onNextClick }) => (
            <>
              {selectedRegion?.service_messages.length > 1 && (
                <div className={s.arrowLeft}>
                  <LeftArrow onClick={onPreviousClick} />
                </div>
              )}

              {selectedRegion?.service_messages.length > 1 && (
                <div className={s.arrowRight} onClick={onNextClick}>
                  <RightArrow />
                </div>
              )}

              <div
                onClick={() => serviceStatusModalRef.current!.closeModal()}
                className="absolute top-0 right-0 flex cursor-pointer items-center justify-center rounded-md p-2 hover:bg-black/60 md:right-2"
              >
                <CloseIcon className="h-8 w-8 fill-white" />
              </div>
            </>
          )}
        </Carousel>
      </Modal>
      {/* upload shopping list modal */}
      <Modal className={s.timeModal} ref={shoppingListModalRef} overflowContent>
        <div
          style={{
            padding: '20px',
            backgroundColor: 'white',
            borderRadius: '10px',
            width:'100%',
            maxWidth: '800px',
            margin: 'auto',
            textAlign: 'center',
            position:'relative'
          }}
        >
          <div
            style={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              marginBottom: '10px',
              flexDirection: 'column',
            }}
          >
            <h2>Send us your order for {selectedBusiness?.name}</h2>
             {preOrderCreated && <p style={{color:'green'}}>{conditionalData?.find(x=> x.id == selectedBusiness?.id)?.custom_order_info?.Notes}</p>}
          </div>
          <div
            style={{
              margin: '20px 0',
              background: '#f3f0f0',
              cursor: 'pointer',
              position:'relative'
            }}
          >
            <label htmlFor="uploadInput" style={{ display: 'block', cursor: 'pointer',padding:'20px 0px' }}>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="80"
                height="80"
                fill="currentColor"
                className="bi bi-camera"
                viewBox="0 0 16 16"
              >
                <path d="M10.5 8a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0z" />
                <path d="M5.05 2h5.9L12 3h3a2 2 0 0 1 2 2v7a2 2 0 0 1-2 2H1a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h3l1.15-1zM1 5v7h14V5H1z" />
              </svg>
              <div style={{ marginTop: '10px', textAlign: 'center' }}>
            <label>
              {preOrderId ? "Add more..." : "Add your shopping list"}
            </label>
              </div>
            </label>
            <input
                  id="uploadInput"
                  type="file"
                  accept="image/*"
                  capture="environment"
                  onChange={(e) => handleImageChange(e)}
                  style={{
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    width: '100%',
                    height: '100%',
                    cursor: 'pointer',
                    opacity:0
                  }}
                />
          </div> 
          <p>
            <a onClick={() => setImageViewerOpen(!isImageViewerOpen)} style={{ cursor: 'pointer', color: 'blue', textDecoration: 'underline' }}>
              Submitted ({noOfFilesUploaded})
            </a>
          </p>
          {isImageViewerOpen && uploadedImages.length > 0 && (
            <div style={{ display: 'flex', gap: '10px', marginTop: '10px', flexWrap:'wrap' }}>
              {uploadedImages.map((item, index) => (
                <div key={index}>
                  {item.ImageUrl && (
                      <img
                        src={item.ImageUrl}
                        alt={`Uploaded ${index + 1}`}
                        style={{
                          width: '200px',
                          height: '200px',
                          borderRadius: '5px',
                          objectFit: 'cover',
                          marginBottom: '5px'
                        }}
                      />
                    )}
                  <p style={{ fontSize: '14px', color: '#555', textAlign: 'center' }}>
                    {item.CustomerNotes ? item.CustomerNotes : "No notes available"}
                  </p>
                </div>
              ))}
            </div>
          )}
          <textarea
              placeholder="Enter order notes"
              value={customOrderNotes}
              onChange={(e) => setCustomOrderNotes(e.target.value)}
              required
              style={{
                width: '100%',
                height: '120px',
                padding: '10px',
                margin: '10px 0',
                borderRadius: '5px',
                border: '1px solid #ccc',
                fontSize: '16px',
                boxSizing: 'border-box',
                resize: 'vertical', // Allow the user to resize the textarea vertically
              }}
            />
            {!preOrderId && (
            <PhoneCountryCodeRow
                phone={phone}
                phoneDialDetails={phoneDialDetails}
                handleCountryCodeChange={handleCountryCodeChange}
                phoneOnChangeHandler={handlePhoneNumberChange}
                phoneNumberLabel ={''}
            />)}

          {previewImage && (
            <div style={{ margin: '20px 0' }}>
              <img
                src={previewImage}
                alt="Preview"
                style={{ maxWidth: '100%', borderRadius: '10px' }}
              />
            </div>
          )}

            <>
              {/* <button
                style={{
                  width: '100%',
                  padding: '10px',
                  backgroundColor: '#4caf50',
                  color: 'white',
                  border: 'none',
                  borderRadius: '5px',
                  cursor: 'pointer',
                  position: 'sticky',
                  bottom: '100px', // Adjusted to be above "I am Done" button
                  left: '0px',
                  marginTop: '10px',
                }}
                onClick={handleAddMoreClick} // Function to handle adding more files
              >
                Add more +
              </button> */}

              <button
                style={{
                  width: '100%',
                  padding: '10px',
                  backgroundColor: '#ff9800',
                  color: 'white',
                  border: 'none',
                  borderRadius: '5px',
                  cursor: 'pointer',
                  position: 'sticky',
                  bottom: '60px', // Space above the "Submit" button
                  left: '0px',
                  marginBottom: '10px',
                  marginTop: '10px',
                }}
                onClick={handleSubmit}
             >
                Send shopping list
              </button>
            </>
          {preOrderId && (
          <button
            style={{
              width: '100%',
              padding: '10px',
              backgroundColor: '#4caf50',
              color: 'white',
              border: 'none',
              borderRadius: '5px',
              cursor: 'pointer',
              position: 'sticky',
              bottom: '10px',
              left: '0px',
              marginTop:'10px'
            }}
            onClick={handleDoneClick}
          >
            I am done
          </button>
)}
        </div>
      </Modal>
      <ConfirmationModal
        ref={waringModalRef}
        onSuccess={handleContinue}
        onCancel={handleCancel}
      >
        <p>
          There are items in your cart. If you change to a different business, your cart will be cleared. Do you want to continue?
        </p>
      </ConfirmationModal>
      <OrderProgressModal ref={orderProgressModalRef} />
    </div>
  )
}

export default Services
